export function mainMenuExtraMarkup() {
  const menus = document.querySelectorAll(".main-menu");
  if (!menus.length) return;

  const liClassName = "menu-item";
  const linkClassName = "menu-link";

  function backMenuItem() {
    const button = document.createElement("button");
    button.type = "button";
    button.classList.add(linkClassName, "menu-link-back");
    button.dataset.dropdownTogglerBack = "";
    button.textContent = "Back";

    const li = document.createElement("li");
    li.classList.add(liClassName, "menu-item-back");
    li.appendChild(button);

    return li;
  }
  const backMenuItemInstance = backMenuItem();

  function virtualPrimaryMenuItem(textContent, href, target) {
    const link = document.createElement("a");
    link.textContent = textContent;
    link.href = href;
    link.classList.add(linkClassName);
    if (target) {
      link.target = target;
    }

    const li = document.createElement("li");
    li.classList.add(
      liClassName,
      "menu-item-primary-virtual",
      "menu-item-type-custom",
    );
    li.appendChild(link);
    return li;
  }

  menus.forEach((menu) => {
    menu.dataset.mainMenu = "";

    // Handle regular dropdown menus
    const menuItemsHaveChildren = menu.querySelectorAll(
      ".menu-item-has-children",
    );
    menuItemsHaveChildren.forEach((menuItem) => {
      //Menu Item
      menuItem.dataset.dropdown = "";
      menuItem.dataset.dropdownLocation = "overlay-menu";

      //Sub Menu
      const subMenu = menuItem.querySelector(":scope > .sub-menu");
      subMenu.dataset.dropdownMenu = "";

      //Menu Link
      const menuLink = menuItem.querySelector(":scope > .menu-link");
      menuLink.dataset.dropdownToggler = "";
      const menuLinkHref = menuLink.getAttribute("href");
      if (menuLinkHref && menuLinkHref !== "#") {
        subMenu.prepend(
          virtualPrimaryMenuItem(
            menuLink.textContent,
            menuLinkHref,
            menuLink.target,
          ),
        );
      }

      //Back Button
      subMenu.prepend(backMenuItemInstance.cloneNode(true));
    });

    // Handle mega menu items
    const megaMenuItems = menu.querySelectorAll(".mega-menu-toggle");
    megaMenuItems.forEach((menuItem) => {
      //Menu Item
      menuItem.dataset.dropdown = "";
      menuItem.dataset.dropdownLocation = "overlay-menu";

      //Mega Menu Content
      const megaMenu = menuItem.querySelector(":scope > .mega-menu");
      if (megaMenu) {
        megaMenu.dataset.dropdownMenu = "";
      }

      //Menu Link
      const menuLink = menuItem.querySelector(":scope > .menu-link");
      if (menuLink) {
        menuLink.dataset.dropdownToggler = "";
        const menuLinkHref = menuLink.getAttribute("href");
        if (menuLinkHref && menuLinkHref !== "#" && megaMenu) {
          megaMenu.prepend(
            virtualPrimaryMenuItem(
              menuLink.textContent,
              menuLinkHref,
              menuLink.target,
            ),
          );
        }
      }

      //Back Button
      if (megaMenu) {
        megaMenu.prepend(backMenuItemInstance.cloneNode(true));
      }
    });
  });
}
